import './main.less';

import React from 'react';
import PropTypes from 'prop-types';

import registrationIcon from '../../../../assets/img/market/registration-icon.svg';
import giftIcon from '../../../../assets/img/market/gift-money.svg';
import presentIcon from '../../../../assets/img/market/present.svg';

const Main = ({ intl }) => (
	<div className='intro'>
		<div className='container'>
			<h1 className='intro-title'>{intl('Gift store')}</h1>
			<div className='intro-wrap'>
				<div className='intro-item'>
					<div className='intro-item__img'>
						<img src={registrationIcon} alt='registration'/>
					</div>
					<p className='intro-item__text'>
						{intl('Register at RocketProfit and')}<br/>
						{intl(' start your traf on converting offers')}
					</p>
				</div>
				<div className="intro-item intro-item_center">
					<div className="intro-item__img">
						<img src={giftIcon} alt="gift-money"/>
					</div>
					<p className="intro-item__text">
						{intl('Получай монеты RocketGOLD')}<br/>
						{` ${intl('за каждый апрувнутый лид')}`}
					</p>
				</div>
				<div className="intro-item">
					<div className="intro-item__img">
						<img src={presentIcon} alt="present"/>
					</div>
					<p className="intro-item__text">
						{intl('Exchange accumulated QUID coins')}<br/>
						{intl(' for valuable gifts')}
					</p>
				</div>
			</div>
		</div>
	</div>
);

Main.propTypes = {
	intl: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/intro/main.js